import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ChatService } from '../services/chat.service';
import { UserAuthService } from '../services/user-auth.service';
import { HeaderComponent } from '../shared/header.component';
import { FooterComponent } from '../shared/footer.component';
import { Router, RouterModule } from '@angular/router';
import { ProfileService } from '../services/profile.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  host: {
    'class': 'd-flex flex-column h-100 iefixfoo'
  },
  styleUrls: ['./layout.component.css'],
  standalone: true,
  imports: [HeaderComponent, FooterComponent, RouterModule]
})
export class LayoutComponent implements OnInit {
  env = environment;
  userData = null;

  constructor(
    private readonly chatService: ChatService,
    private readonly userAuthService: UserAuthService,
    private readonly profileService: ProfileService,
    private readonly router: Router
  ) { }

  ngOnInit() {
    this.verifyMfaCompleted();

    this.userData = this.userAuthService.getIdentityClaims();
    if (!this.userData) {
      return;
    }

    const requestParams = {
       firstName: this.userData.given_name,
       idNumber: this.userData.extension_IdNumber || this.userData.name,
       surname: this.userData.family_name
      };
    if ((window as any).fcWidget) {
      this.initFreshChatWidget(requestParams);
    }
  }

  private verifyMfaCompleted() {
    if (sessionStorage.getItem('cellVerificationDone') === 'true') {
      return;
    }

    this.profileService.userProfile().subscribe({
      next: (data: any) => {
        if (data?.cellNumberVerifiedByUser || !data?.phoneNumber) {
          this.profileService.markCellVerificationDone();
          return;
        }
        this.router.navigate(['/authenticate'], { replaceUrl: true });
      },
      error: () => {
        this.router.navigate(['/login'], { replaceUrl: true });
      }
    });
  }

  private initFreshChatWidget(requestParams: any) {
    (window as any).fcWidget.init({
      token: this.env.freshChatToken, host: this.env.freshChatHost,
      firstName: requestParams.firstName, externalId: requestParams.idNumber, lastName: requestParams.surname
    });

    (window as any).fcWidget.user.get((resp) => this.handleFcWidgetUserGet(resp, requestParams));
  }

  private handleFcWidgetUserGet(resp: any, requestParams: any) {
    if (resp.status !== 200) {
      (window as any).fcWidget.user.setProperties({
        firstName: requestParams.firstName,
        lastName: requestParams.surname
      });

      (window as any).fcWidget.on('user:created', (resp1) => this.handleFcWidgetUserCreated(resp1, requestParams));
    }
  }

  private handleFcWidgetUserCreated(resp1: any, requestParams: any) {
    console.log('user created');

    if (resp1.status === 200) {
      (window as any).fcWidget.user.get((resp) => this.saveChatLog(resp, requestParams));
    }
  }

  private saveChatLog(resp: any, requestParams: any) {
    const param = {
      Endpoint: globalThis.location.href,
      IdNumber: this.userData.idNumber,
      RequestParam: JSON.stringify(requestParams),
      RequestTime: new Date(),
      ResponseData: JSON.stringify(resp),
      ResponseTime: new Date()
    };

    this.chatService.saveChat(param).subscribe({
      next: () => {}
    });
  }

}
